import m from './module';
import LocationVariable from '../model/LocationVariable';

const path = '/location_variable';
const type = 'LocationVariable';

class LocationVariableService {
  constructor($q, APIService, DataSyncService) {
    "ngInject";
    this.$q = $q;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    return this.createIsolated(data)
      .then(lv => {
        if (lv.id) {
          return this.DataSyncService.setObjectById(type, lv.id, lv);
        } else {
          return lv;
        }
      });
  }

  createIsolated(data) {
    return this.$q.when(new LocationVariable(data));
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple(type, path, id, data => this.create(data), config);
  }

  getByIds(id_list, config = null) {
    return this.$q.all(
      id_list.map(id => this.getById(id, config))
    );
  }
}

export default LocationVariableService;

m.service('LocationVariableService', LocationVariableService);
